import './App.css'
import { Index } from './page'

function App() {

  return (
    <Index />
  )
}

export default App
